<div
  class="card-alerta"
  [ngClass]="{
    'pendente': !alert.respondido_em,
    'finalizado': alert.respondido_em,
    'classificacao-critico': alert.classificacao_id >= 3,
    'classificacao-moderado': alert.classificacao_id === 2,
    'classificacao-leve': alert.classificacao_id <= 1
  }"
  role="article"
  [attr.aria-label]="getCardAriaLabel()"
  tabindex="0"
  (keydown)="handleKeyDown($event)"
>
  <!-- BARRA LATERAL DE ACENTO DE RISCO -->
  <div class="card-accent-bar" aria-hidden="true"></div>

  <div class="card-content-wrap">
    <!-- LINHA SUPERIOR: PACIENTE + STATUS -->
    <div class="card-header-row">
      <div class="patient-box">
        <div class="patient-avatar">
          {{ alert.paciente_nome ? alert.paciente_nome.charAt(0) : 'P' }}
        </div>
        <div class="patient-titles">
          <h4 class="patient-name" id="paciente-{{alert.alerta_id}}" [title]="alert.paciente_nome">
            {{ alert.paciente_nome }}
          </h4>
          <span class="patient-unit">
            <mat-icon class="icon-tiny">local_hospital</mat-icon>
            {{ alert.unidade_nome || 'Unidade' }}
          </span>
        </div>
      </div>

      <div class="card-status-badges">
        @if (alert.respondido_em) {
          <span class="status-chip chip-finalizado">
            <mat-icon>check_circle</mat-icon>
            Finalizado
          </span>
        } @else {
          <span class="status-chip chip-pendente">
            <mat-icon>schedule</mat-icon>
            Pendente
          </span>
        }
      </div>
    </div>

    <!-- CAIXA DE DESTAQUE DA GLICEMIA -->
    <div class="glycemia-box">
      <div class="metric-group">
        <div class="metric-icon-circle">
          <mat-icon>water_drop</mat-icon>
        </div>
        <div class="metric-info">
          <span class="metric-sub">Glicemia</span>
          <div class="metric-number-row">
            <strong
              id="medicao-{{alert.alerta_id}}"
              class="metric-val"
              [ngClass]="{
                'val-critico': alert.classificacao_id >= 3,
                'val-moderado': alert.classificacao_id === 2,
                'val-leve': alert.classificacao_id <= 1
              }"
            >
              {{ alert.valor_medido }}
            </strong>
            <span class="metric-unit">mg/dL</span>
          </div>
        </div>
      </div>

      <div class="context-badge" [title]="alert.contexto_nome">
        <mat-icon>restaurant</mat-icon>
        <span class="context-text">{{ alert.contexto_nome || 'Refeição' }}</span>
      </div>
    </div>

    <!-- DATA/HORA E TEMPO DECORRIDO -->
    <div class="card-meta-bar">
      <div class="meta-datetime">
        <mat-icon>event</mat-icon>
        <time [attr.datetime]="alert.criado_em">
          {{ alert.criado_em.split(' ')[0].split('-').reverse().join('/') }}
          @if (alert.criado_em.split(' ')[1]) {
            às {{ alert.criado_em.split(' ')[1].substring(0, 5) }}
          }
        </time>
      </div>

      @if (alert.minutos_passados) {
        <span class="elapsed-tag" [class.elapsed-late]="alert.status_tempo === 'ATRASADO'">
          {{ alert.minutos_passados }} min
        </span>
      }
    </div>

    <!-- AÇÕES RÁPIDAS (ALERTAS PENDENTES) -->
    @if (!alert.respondido_em) {
      <div class="card-actions-bar" role="group" aria-label="Ações do alerta">
        <button
          type="button"
          class="btn-act btn-act-details"
          matTooltip="Abrir detalhes e prontuário"
          (click)="openModal(alert)"
        >
          <mat-icon>visibility</mat-icon>
          <span>Detalhes</span>
        </button>

        @if (loading_wpp) {
          <div class="action-spinner" role="status" aria-label="Carregando WhatsApp">
            <mat-spinner diameter="18"></mat-spinner>
          </div>
        } @else {
          <button
            type="button"
            class="btn-act btn-act-wpp"
            matTooltip="WhatsApp do paciente"
            (click)="whatsapppaciente(alert.alerta_id)"
          >
            <mat-icon>chat</mat-icon>
            <span>WhatsApp</span>
          </button>
        }

        @if (loading_tutor) {
          <div class="action-spinner" role="status" aria-label="Acionando tutor">
            <mat-spinner diameter="18"></mat-spinner>
          </div>
        } @else {
          <button
            type="button"
            class="btn-act btn-act-icon btn-act-tutor"
            matTooltip="Acionar Tutor Local"
            (click)="acionartutorlocal(alert.alerta_id)"
          >
            <mat-icon>how_to_reg</mat-icon>
          </button>
        }

        @if (loading_finalizar) {
          <div class="action-spinner" role="status" aria-label="Finalizando alerta">
            <mat-spinner diameter="18"></mat-spinner>
          </div>
        } @else {
          <button
            type="button"
            class="btn-act btn-act-icon btn-act-finish"
            matTooltip="Finalizar este alerta"
            (click)="finalizar(alert.alerta_id)"
          >
            <mat-icon>check_circle</mat-icon>
          </button>
        }
      </div>
    }

    <!-- ALERTA FINALIZADO -->
    @if (alert.respondido_em) {
      <div class="finalized-container">
        <div class="finalized-badge">
          <mat-icon>task_alt</mat-icon>
          <span>
            Finalizado em
            <strong>{{ alert.respondido_em.split(' ')[0].split('-').reverse().join('/') }}</strong>
            @if (alert.respondido_em.split(' ')[1]) {
              às <strong>{{ alert.respondido_em.split(' ')[1].substring(0, 5) }}</strong>
            }
          </span>
        </div>

        <div class="card-actions-bar finalized-actions" role="group" aria-label="Ações do alerta finalizado">
          <button
            type="button"
            class="btn-act btn-act-details btn-resolution"
            matTooltip="Visualizar resolução e prontuário completo"
            (click)="openModal(alert)"
          >
            <mat-icon>visibility</mat-icon>
            <span>Ver Resolução</span>
          </button>

          @if (alert.telefone_whatsapp) {
            <button
              type="button"
              class="btn-act btn-act-wpp"
              matTooltip="WhatsApp do paciente"
              (click)="whatsapppaciente(alert.alerta_id)"
            >
              <mat-icon>chat</mat-icon>
              <span>WhatsApp</span>
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
